<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 23 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M19.834 0C20.5574 0 21.1458 0.590055 21.1458 1.31545L21.1455 2.783L21.688 2.78326C22.3689 2.78326 22.9302 3.30594 22.9939 3.9722L22.9999 4.09872V8.05017C22.9999 8.77562 22.4114 9.36562 21.688 9.36562L21.1455 9.36483L21.1458 11.1429C21.1458 11.8255 20.6246 12.3884 19.9601 12.4521L19.834 12.4581H17.3457V0H19.834ZM5.7168 0.00022834V12.4584H3.22853C2.50506 12.4584 1.91667 11.8683 1.91667 11.1429V9.36485L1.31186 9.36575C0.630948 9.36575 0.0696899 8.84293 0.0060156 8.17678L0 8.05029V4.09884C0 3.37339 0.588444 2.78339 1.31186 2.78339L1.91667 2.78302V1.31568C1.91667 0.633102 2.43792 0.0701324 3.10236 0.00626247L3.22853 0.00022834H5.7168ZM16.0997 3.99756H6.9668V8.46087H16.0997V3.99756Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgNFOPActiveFit',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>